import type { SVGProps } from "react";
export function Facebook(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        d="m8.00004 1.33337c-3.682 0-6.66667 2.98467-6.66667 6.66667 0 3.32736 2.438 6.08536 5.62534 6.58596v-4.65929h-1.69334v-1.92667h1.69334v-1.46867c0-1.67066.99466-2.59333 2.518-2.59333.72929 0 1.49199.13 1.49199.13v1.64h-.84c-.82866 0-1.08666.514-1.08666 1.04133v1.25067h1.84866l-.2953 1.92667h-1.55336v4.65929c3.18666-.5 5.62466-3.2593 5.62466-6.58596 0-3.682-2.9847-6.66667-6.66666-6.66667z"
        fill="currentColor"
      />
    </svg>
  );
}
